import { useEffect, useRef } from 'react';

/**
 * Refreshes server-owned state when a tab becomes active again, including browser back/forward restores.
 */
export const usePageActivationRefresh = (
    enabled: boolean,
    refresh: () => Promise<unknown> | void
) => {
    const refreshRef = useRef(refresh);

    useEffect(() => {
        refreshRef.current = refresh;
    }, [refresh]);

    useEffect(() => {
        if (!enabled) {
            return undefined;
        }

        const runRefresh = () => {
            void refreshRef.current();
        };
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                runRefresh();
            }
        };

        window.addEventListener('focus', runRefresh);
        window.addEventListener('pageshow', runRefresh);
        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            window.removeEventListener('focus', runRefresh);
            window.removeEventListener('pageshow', runRefresh);
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [enabled]);
};
